import { useTranslation } from "react-i18next";
import { Button } from "~/components/button/button";
import { Icon } from "~/components/icon/icon";
import { Card, CardContent } from "~/components/ui/card";
import { Text } from "~/components/text";

interface EmptyStateProps {
  onUploadClick: (e: React.MouseEvent) => void;
}

export const EmptyState = ({ onUploadClick }: EmptyStateProps) => {
  const { t } = useTranslation(["uploadManuscript", "books"]);

  return (
    <div>
      <Card className="shadow-xs">
        <CardContent className="flex flex-col items-center justify-center py-8">
          <Icon size="large" name="upload" iconClassName="text-primary-600" />
          <div className="max-w-lg flex flex-col items-center text-center gap-2 pt-8 pb-6 space-y-2">
            <Text as="span" variant="body">
              {t("uploadManuscript:subtitle")}
            </Text>
            <Text as="span" variant="subtle">
              {t("uploadManuscript:description")}
            </Text>
          </div>
          <Button
            icon="upload"
            variant="ghost"
            analyticsId="button_upload_manuscript"
            label={t("uploadManuscript:button.upload")}
            onClick={(e) => {
              e.stopPropagation();
              onUploadClick(e);
            }}
          />
        </CardContent>
      </Card>
      <Text variant="subtle" className="text-center mt-2">
        {t("uploadManuscript:footer")}
      </Text>
    </div>
  );
};
